module.exports = __webpack_public_path__ + "static/original-1-c7a278dec6868199f739cd64b88b1289.png";